export default (url: string) => window.location.replace(url)
